import type { FunctionComponent } from 'react';
import get from 'lodash/get';
import { Link, Navigate, useLocation } from 'react-router-dom';
import Layout from '../../components/Layout';
import { usePageTracking } from '../../hooks/usePageTracking';
import fffPng from './assets/access-image@3x.png';
import { ReactComponent as WaveSvg } from './assets/bottom-swoop.svg';
import emojiPng from './assets/heart-face-emoji.png';
import * as styles from './giftConfirmation.module.scss';

type LocationState = {
  recipient: {
    email: string;
    name?: string;
    message?: string;
  };
  sender: {
    name: string;
  };
  response?: {
    amount: number;
    code: string;
  };
};

const GiftConfirmation: FunctionComponent = () => {
  const location = useLocation();
  const state = location.state as LocationState | null;
  usePageTracking();

  if (!state) {
    return <Navigate to="/gift" replace />;
  }

  return (
    <Layout pageTitle="FabFitFun E-Gift Card">
      <main className={styles.container}>
        <section className={styles.header}>
          <h2>
            <img src={emojiPng} alt="🥰" />
          </h2>
          <h3>
            You’ve Just Sent a ${get(state, 'response.amount', 0) / 100} E-Gift Card to{' '}
            {get(state, 'recipient.name')}!
          </h3>
          <p className={styles.text}>
            We’ve sent you a confirmation email with all the details of your purchase and a separate
            email with an e-gift card code attached.
          </p>
          <p className={styles.email}>
            Here’s the email we’ve sent your friend ({get(state, 'recipient.email')}
            ):
          </p>
        </section>
        <section className={styles.giftCard}>
          <div className={styles.wave}>
            <h3>{get(state, 'sender.name')} Just Sent You a FabFitFun Gift Certificate!</h3>
            <p className={styles.message}>{get(state, 'recipient.message')}</p>
            <img src={fffPng} alt="FabFitFun" />
            <WaveSvg />
          </div>
          <div className={styles.details}>
            <p className={styles.amount}>
              Gift Card Amount:
              <span>${get(state, 'response.amount', 0) / 100}</span>
            </p>
            <p className={styles.code}>
              Gift Card Code:
              <span>{get(state, 'response.code')}</span>
            </p>
          </div>
        </section>
        <section className={styles.sendAnother}>
          <Link to="/gift">Send Another Gift Card</Link>
        </section>
      </main>
    </Layout>
  );
};

export default GiftConfirmation;
